import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { EntityForm } from '@/components/forms/EntityForm';
import { useLabel, useUpdateLabel } from '@/features/labels/labels.hooks';
import { labelDetailLayout } from '@/features/labels/labels.schemas';
import { useEntityForm } from '@/hooks/useEntityForm';
import { getDirtyValues } from '@/lib/form-utils';
import { toast } from 'sonner';
import { getLabelActions, adaptActionsForPanel } from './labels.actions';
import { EntityFormHeaderActions } from '@/components/forms/EntityFormHeaderActions';
import { useMemo } from 'react';

export const LabelDetailsPanel = ({
  params,
  path,
  basePath,
  ...panelProps
}: RoutedPanelProps) => {
  const { labelId } = params;
  const labelQuery = useLabel(parseInt(labelId));

  const entityForm = useEntityForm({
    layout: labelDetailLayout,
    ...labelQuery,
  });

  const updateLabelMutation = useUpdateLabel();

  const actions = useMemo(() => {
    if (!labelQuery.data) return [];
    const rowActions = getLabelActions();
    return adaptActionsForPanel(rowActions, labelQuery.data);
  }, [labelQuery.data]);

  const labelName = labelQuery.data?.name;
  const title = `Label: ${labelName || labelId}`;

  const headerActions = (
    <EntityFormHeaderActions
      entityForm={entityForm}
      formId="label-details-form"
    />
  );

  return (
    <Panel
      {...panelProps}
      title={title}
      actions={entityForm.formMode === 'view' ? actions : undefined}
      headerActions={headerActions}
    >
      <EntityForm
        {...entityForm}
        id="label-details-form"
        hideActions={true}
        onSubmit={entityForm.form.handleSubmit(
          async () => {
            const dirtyValues = getDirtyValues(
              entityForm.form.formState.dirtyFields,
              entityForm.form.getValues(),
            );
            await updateLabelMutation.mutateAsync({
              recnum: labelId,
              ...dirtyValues,
            });
            entityForm.setFormMode('view');
          },
          (errors) => {
            console.log('Form validation errors:', { errors });
            toast.error('Please fix the validation errors');
          },
        )}
      />
    </Panel>
  );
};
